import { render, staticRenderFns } from "./ModifyPWD.vue?vue&type=template&id=759c7c40&scoped=true"
import script from "./ModifyPWD.vue?vue&type=script&lang=js"
export * from "./ModifyPWD.vue?vue&type=script&lang=js"
import style0 from "./ModifyPWD.vue?vue&type=style&index=0&id=759c7c40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759c7c40",
  null
  
)

export default component.exports